import prices from './prices';
import billingProfiles from './billing-profiles';

export default {
  prices,
  billingProfiles,
};
